export default __webpack_public_path__ + "static/media/bgAsideDt.794e7fa4.png";